// OkumaHatasi.js — DÜŞEN / KESİK OKUMA KUTUSU, TEK TİP (6 Eki 2026)
//
// 🔑 Okuma düşerse ya da eksik gelirse ekran yarım veriyle hesap göstermez; bu kutu okumayı ADIYLA ve
//    sunucunun KENDİ cümlesiyle (ya da "1000 of 1250" sayılarıyla) söyler, RETRY verir. Eskiden yalnız FTL
//    panelinde vardı (29 Eyl 2026); AIRCRAFTS da aynısını kullanır — Serkan: tek tip, tek kaynak.
//    Satırları `okumaDenetimi()` (kesikOkuma.js) toplar.
import React from 'react';
import { dugmeStili } from './tasarim';

export default function OkumaHatasi({ testid, baslik, satirlar, onRetry, style }) {
  return (
    <div data-testid={testid} style={{ fontSize:11, fontFamily:'var(--mono)', lineHeight:1.8, ...style }}>
      <div style={{ color:'var(--red)', fontWeight:700, letterSpacing:1 }}>{baslik}</div>
      {satirlar.map(h => (
        <div key={h.ad} style={{ color:'var(--t2)' }}>· {h.ad}: {h.metin}</div>
      ))}
      <button style={{ ...dugmeStili('notr'), marginTop:14 }} onClick={onRetry}>RETRY</button>
    </div>
  );
}
